// src/services/mailDirectoryApi.js
// Cliente del módulo Directorio de correos DreamHost. Aislado del resto: sus
// endpoints viven bajo /mail-directory y solo los consume esta pantalla.
import api from './api';

export const listMailboxes = (params = {}) =>
    api.get('/mail-directory', { params }).then((r) => r.data);

export const getResumen = () =>
    api.get('/mail-directory/resumen').then((r) => r.data);

export const getDominios = () =>
    api.get('/mail-directory/dominios').then((r) => r.data);

const enc = (email) => encodeURIComponent(email);

export const confirmar = (email, idEmpleado, nota) =>
    api.post(`/mail-directory/${enc(email)}/confirmar`, { idEmpleado, nota }).then((r) => r.data);

export const marcarSinMatch = (email, nota) =>
    api.post(`/mail-directory/${enc(email)}/sin-match`, { nota }).then((r) => r.data);

export const cuentaArea = (email, nota) =>
    api.post(`/mail-directory/${enc(email)}/cuenta-area`, { nota }).then((r) => r.data);

export const reabrir = (email) =>
    api.post(`/mail-directory/${enc(email)}/reabrir`).then((r) => r.data);

export const solicitarBaja = (email, activar = true) =>
    api.post(`/mail-directory/${enc(email)}/solicitar-baja`, { activar }).then((r) => r.data);

export const syncAhora = () =>
    api.post('/mail-directory/sync').then((r) => r.data);

// Administración de la lista blanca (solo admin).
export const getAccess = () =>
    api.get('/mail-directory/access').then((r) => r.data);

export const setAccess = (userId, allow) =>
    api.post('/mail-directory/access', { userId, allow }).then((r) => r.data);

// Contraseña por buzón (cifrada).
export const guardarPassword = (email, password) =>
    api.post(`/mail-directory/${enc(email)}/password`, { password }).then((r) => r.data);

export const borrarPassword = (email) =>
    api.delete(`/mail-directory/${enc(email)}/password`).then((r) => r.data);

export const revelarPassword = (email) =>
    api.post(`/mail-directory/${enc(email)}/password/revelar`).then((r) => r.data);

// Conexión a DreamHost (cookie) para la extracción automática.
export const getConfig = () =>
    api.get('/mail-directory/config').then((r) => r.data);

export const setCookie = (cookie) =>
    api.post('/mail-directory/config/cookie', { cookie }).then((r) => r.data);

export const extraerAhora = () =>
    api.post('/mail-directory/extraer').then((r) => r.data);
